module.exports = __webpack_public_path__ + "static/img/conmicarano-1.056a05d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/conmicarano-1.jpg
// module id = w6Tm
// module chunks = 1